import { BotIntent } from '../types/intent.types';

export const BOT_INTENTS = {
  TRACK_SHIPMENT: 'track_shipment' as BotIntent,
  GET_RATES: 'get_rates' as BotIntent,
  PLACE_SHIPMENT: 'place_shipment' as BotIntent,
  CREATE_INVOICE: 'create_invoice' as BotIntent,
  DOWNLOAD_REPORT: 'download_report' as BotIntent,
  SHIPMENT_STATUS: 'shipment_status' as BotIntent,
  FIND_QUOTES: 'find_quotes' as BotIntent,
  CANCEL_SHIPMENT: 'cancel_shipment' as BotIntent,
  REPEAT_SHIPMENT: 'repeat_shipment' as BotIntent,
  DOWNLOAD_AWB: 'download_awb' as BotIntent,
  UPDATE_SHIPMENT: 'update_shipment' as BotIntent,
  UPDATE_SHIPMENT_STATUS: 'update_shipment_status' as BotIntent,
} as const;
